<template>
  <div>
    <a-table
        :columns="columns"
        :loading="loading"
        :style="{margin:'auto',background:'#fff'}"
        :dataSource="deletionRequest.data"
        :bordered="false"
        :rowKey="record => record.id"
        :pagination="false"
    >
      <span slot="name" slot-scope="name,rowData">
        <router-link :to="{name:'sites.overview',params:{siteId:rowData.id}}">
        {{ name }}
          <a-tag :color="'geekblue'" v-if="rowData.is_vip_site">VIP</a-tag>
        </router-link>
      </span>

      <a-tag slot="plan" slot-scope="name, rowData">
        {{ rowData.plan ? 'Paid' : 'Free' }}
      </a-tag>

      <a-tag slot="due_invoice" slot-scope="name, rowData"
             :color="rowData.due_invoice ? 'green' : 'volcano'"
      >
        {{ rowData.due_invoice ? 'No' : 'Yes' }}
      </a-tag>

      <a-tag slot="status" slot-scope="name, rowData"
             :color="rowData.status ? 'green' : 'volcano'">
        {{ rowData.status ? 'Active' : 'Deactivated' }}
      </a-tag>
      <span slot="approval" slot-scope="name, rowData">
         <a-switch checked-children="Approved"
                   un-checked-children="Pending"
                   :default-checked="rowData.approval == 'approved'"
                   @change="updateStatus(rowData.id)"
         />
      </span>
    </a-table>

    <div class="pagination" style="font-weight: normal; float: right; margin-top: 20px; margin-bottom: 20px;" v-if="deletionRequest.meta">
      <span>total {{ deletionRequest.meta.total }} items</span>
      <span style="margin-left: 15px; margin-right: 15px; color: #cecece;">|</span>
      <span>page {{ deletionRequest.meta.current_page }} of {{ deletionRequest.meta.last_page }}</span>
      <span style="margin-left: 15px; margin-right: 15px; color: #cecece;" v-if="deletionRequest.meta.last_page > 1">|</span>
      <a :disabled="deletionRequest.meta.current_page == 1"
         style="margin-right: 10px;"
         class="pagination--btn"
         @click.prevent="getDeletionRequests(deletionRequest.meta.current_page - 1)"
         v-if="deletionRequest.meta.last_page > 1"
      >&lt; Previous</a>
      <a
          :disabled="deletionRequest.meta.current_page == deletionRequest.meta.last_page"
          class="pagination--btn"
          @click.prevent="getDeletionRequests(deletionRequest.meta.current_page + 1)"
          v-if="deletionRequest.meta.last_page > 1"
      >Next &gt;</a>
    </div>
  </div>
</template>
<script>
import Api from "@/services/Api";

export default {
  data() {
    return {
      columns: [
        {
          title: "Sites",
          dataIndex: "name",
          key: "name",
          scopedSlots: { customRender: "name" }
        },
        {
          title: "Status",
          dataIndex: "status",
          key: "status",
          scopedSlots: { customRender: "status" }
        },
        {
          title: "Plan",
          dataIndex: "plan",
          key: "plan",
          scopedSlots: { customRender: "plan" }
        },
        {
          title: "Due Invoice",
          dataIndex: "due_invoice",
          key: "due_invoice",
          scopedSlots: { customRender: "due_invoice" }
        },
        {
          title: "Request at",
          dataIndex: "request_date",
          sorter: () => {},
          key: "request_date"
        },
        {
          title: "Approval",
          dataIndex: "approval",
          key: "approval",
          sorter: () => {},
          scopedSlots: { customRender: "approval" }
        },
      ],
      loading: false,
      deletionRequest: [],
    };
  },
  methods: {
    getDeletionRequests(page = 1) {
      Api.get(`/data-deletion?page=${page}`)
        .then(({ data }) => {
          this.deletionRequest = data;
        })
        .catch(({ response }) => {
          this.$notification['error']({
            message: 'Error',
            description: response.data.message ? response.data.message : 'Something went wrong!'
          });
        })
    },
    updateStatus(siteId) {
      this.loading = true;
      Api.put(`data-deletion/sites/${siteId}`)
          .then(resp => {
            this.loading = false;
            this.$notification['success']({
              message: 'Request status has changed',
              description: resp.data.data
            });
          }).catch(err => {
            // eslint-disable-next-line
            console.log(err)
            this.loading = false;
                this.$notification['error']({
                    message: 'Error',
                    description: 'Something went wrong!'
                });
          });
    }
  },
  created() {
    this.getDeletionRequests();
  }
};
</script>

<style scoped lang="scss">
.pagination--btn {
  background-color: #e5e5e5;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 5px 9px;
  line-height: 1.8;
}
.table--header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
</style>
